module.exports = __webpack_public_path__ + "static/media/app3.7c3ab723.jpg";